import { CSSProperties } from 'react';

const containerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  backgroundColor: 'var(--bui-bg-app)',
  fontFamily: 'var(--bui-font-regular)',
  padding: 'var(--bui-space-6)',
};

const cardStyle: CSSProperties = {
  maxWidth: 520,
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--bui-space-4)',
  padding: 'var(--bui-space-6)',
  backgroundColor: 'var(--bui-bg-neutral-1)',
  borderRadius: 'var(--bui-radius-3)',
  border: '1px solid var(--bui-border-danger)',
};

const titleStyle: CSSProperties = {
  fontSize: 'var(--bui-font-size-5)',
  fontWeight: 'var(--bui-font-weight-bold)',
  color: 'var(--bui-fg-primary)',
  margin: 0,
};

const messageStyle: CSSProperties = {
  fontSize: 'var(--bui-font-size-3)',
  color: 'var(--bui-fg-secondary)',
  lineHeight: 1.5,
  margin: 0,
};

const linkStyle: CSSProperties = {
  color: 'var(--bui-fg-primary)',
  fontWeight: 'var(--bui-font-weight-bold)',
};

const buttonStyle: CSSProperties = {
  padding: 'var(--bui-space-2) var(--bui-space-5)',
  fontSize: 'var(--bui-font-size-3)',
  fontWeight: 'var(--bui-font-weight-bold)',
  fontFamily: 'var(--bui-font-regular)',
  color: 'var(--bui-fg-solid)',
  backgroundColor: 'var(--bui-bg-solid)',
  border: 'none',
  borderRadius: 'var(--bui-radius-full)',
  cursor: 'pointer',
};

export const AppCrashFallback = () => (
  <div style={containerStyle}>
    <div style={cardStyle}>
      <h1 style={titleStyle}>Oops, something went wrong…</h1>
      <p style={messageStyle}>
        Sorry, looks like we encountered an error. Try refreshing the page, or
        contact our{' '}
        <a href="mailto:experimentation-cs@spotify.com" style={linkStyle}>
          Customer Support team
        </a>{' '}
        for help.
      </p>
      <div>
        <button onClick={() => window.location.reload()} style={buttonStyle}>
          Reload page
        </button>
      </div>
    </div>
  </div>
);
